<template>
  <div class="browser-message">
    <el-row class="description">
      <h1 v-html="title"></h1>
      <div class="row-center">
        <p v-html="description"></p>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      //
    };
  }
};
</script>
